import { Controller } from 'stimulus'
import toastr from 'toastr'

export default class extends Controller {
  static targets = ['card', 'cardBody', 'adjustForm', 'commentForm', 'qtyRemaining']

  toggleVerified(event) {
    const card = event.currentTarget.closest('[data-stocktake-target="card"]')
    if (!card) return

    const isVerified = card.dataset.verified === 'true'
    card.dataset.verified = isVerified ? 'false' : 'true'
    const body = card.querySelector('[data-stocktake-target="cardBody"]')

    if (!isVerified) {
      card.classList.add('bg-green-100')
      card.classList.remove('bg-white')
      if (body) body.classList.add('hidden')
      // Close any open forms
      const adjustForm = card.querySelector('[data-stocktake-target="adjustForm"]')
      const commentForm = card.querySelector('[data-stocktake-target="commentForm"]')
      if (adjustForm) adjustForm.classList.add('hidden')
      if (commentForm) commentForm.classList.add('hidden')
    } else {
      card.classList.remove('bg-green-100')
      card.classList.add('bg-white')
      if (body) body.classList.remove('hidden')
    }
  }

  expandAdjust(event) {
    const card = event.currentTarget.closest('[data-stocktake-target="card"]')
    if (!card) return

    const form = card.querySelector('[data-stocktake-target="adjustForm"]')
    if (form) form.classList.toggle('hidden')
  }

  expandComment(event) {
    const card = event.currentTarget.closest('[data-stocktake-target="card"]')
    if (!card) return

    const form = card.querySelector('[data-stocktake-target="commentForm"]')
    if (form) form.classList.toggle('hidden')
  }

  async submitAdjust(event) {
    event.preventDefault()
    const form = event.currentTarget
    const url = form.action
    const formData = new FormData(form)

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json'
        },
        body: formData
      })

      if (response.ok || response.redirected) {
        const card = form.closest('[data-stocktake-target="card"]')
        const qtyField = card.querySelector('[data-stocktake-target="qtyRemaining"]')
        const qtyUsed = parseFloat(formData.get('item_use[qty_used]')) || 0

        if (qtyField) {
          const current = parseFloat(qtyField.dataset.qty) || 0
          const updated = current - qtyUsed
          qtyField.dataset.qty = updated
          qtyField.textContent = updated
        }

        form.reset()
        form.classList.add('hidden')
        toastr.success('Quantity adjusted successfully.')
      } else {
        toastr.error('Failed to adjust quantity.')
      }
    } catch (error) {
      toastr.error('Unexpected error occurred.')
    }
  }

  async submitComment(event) {
    event.preventDefault()
    const form = event.currentTarget
    const url = form.action
    const formData = new FormData(form)

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json'
        },
        body: formData
      })

      if (response.ok || response.redirected) {
        form.reset()
        form.classList.add('hidden')
        toastr.success('Comment added successfully.')
      } else {
        toastr.error('Failed to add comment.')
      }
    } catch (error) {
      toastr.error('Unexpected error occurred.')
    }
  }
}
